module.exports = __webpack_public_path__ + "media/images/application/social_sharing/facebook-d866e9b77f86e555e17195c1f03d0ab0.png";